import { useContext, useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AuthContext } from './AuthContext';

/**
 * Clears React Query cache when the signed-in user changes or on logout.
 * Prevents showing the previous user's my-issues / board data after login switch.
 */
export default function AuthQueryCacheSync() {
  const { user, sessionReady } = useContext(AuthContext);
  const qc = useQueryClient();
  const prevUserIdRef = useRef(undefined);

  useEffect(() => {
    if (!sessionReady) return;

    const currentUserId = user?.id != null ? String(user.id) : null;
    const prevUserId = prevUserIdRef.current;

    if (prevUserId !== undefined && prevUserId !== currentUserId) {
      qc.clear();
    }

    prevUserIdRef.current = currentUserId;
  }, [user?.id, sessionReady, qc]);

  return null;
}
